import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";

function Units() {
  const initialForm = {
    store_settings_unit_name: "",
    alertMsg: "",
    alertMsgTyp: "",
    isAlert: false,
  };

  const [formData, setFormData] = useState(initialForm);
  const [ldata, setLdata] = useState(null);
  const [records, setRecords] = useState([]);
  const [isAdmin , setIsAdmin] = useState('')

  // ✅ handleChange
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ✅ handleSubmit (Insert / Update)
  const handleSubmit = async (e) => {
    e.preventDefault();

    const fd = new FormData();
    fd.append("store_settings_unit_name", formData.store_settings_unit_name);
    fd.append("store_settings_user", ldata?.user_id);

    try {
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.CreateStoreUnits,
        fd,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.data.status) {
        setFormData(initialForm);
        fetchRecords();
        toast.success("Saved Successfully");
      } else {
        toast.error("Failed to Save");
      }
    } catch (error) {
      toast.error("Error while saving data");
    }
  };

  // ✅ Fetch All Records
  const fetchRecords = async () => {
    try {
      const response = await axios.get(
        AppConst.BASE_URL + AppConst.GetAllStoreUnits
      );
      if (response.data.status) {
        setRecords(response.data.list);
      }
    } catch (err) {
      toast.error("Error fetching records");
    }
  };

  // ✅ Edit Record
  const handleEdit = (rec) => {
    setFormData({
      ...formData,
      store_settings_unit_name: rec.store_settings_unit_name,
    });
  };

  // ✅ Delete Record
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure to delete this record?")) return;

    try {
      const fd = new FormData();
      fd.append("id", id);

      const response = await axios.post(
        AppConst.BASE_URL + AppConst.DeleteUnitUrl,
        fd
      );

      if (response.data.status) {
        toast.success("Deleted Successfully");
        fetchRecords();
      } else {
        toast.error("Failed to Delete");
      }
    } catch (err) {
      toast.error("Error deleting record");
    }
  };

  // ✅ Initial Load
  useEffect(() => {
    const storedData = sessionStorage.getItem("ldata");
      const userData = JSON.parse(sessionStorage.getItem("ldata"));
  const roleId = userData?.role_id;
    if (roleId === 1 || roleId === "1") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
    }
    fetchRecords();
  }, []);

  return (
    <div class="page-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-xxl-12">
            <div class="card">
              <div class="card-body">
                <h5>Units</h5> 
                <br />
                <div class="live-preview">
                  <form onSubmit={handleSubmit}>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label class="form-label">Unit Name</label>
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Enter Unit Name"
                            name="store_settings_unit_name"
                            onChange={handleChange}
                            value={formData.store_settings_unit_name}
                          />
                        </div>
                      </div>

                     

                      <div class="col-lg-12">
                        <div class="text-end">
                          <button type="submit" class="btn btn-primary">
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* ✅ Records Table */}
            <div class="card mt-4">
              <div class="card-body">
                <h5>Units Records</h5> 
                <table class="table table-bordered mt-3">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Unit Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {records.length > 0 ? (
                      records.map((rec, index) => (
                        <tr key={rec.store_settings_id}>
                          <td>{index + 1}</td>
                          <td>{rec.store_settings_unit_name}</td>
                          <td>
                            <button
                              class="btn btn-sm btn-info me-2"
                              onClick={() => handleEdit(rec)}
                                   disabled={!isAdmin} // ❌ normal user ke liye disable
                                                         style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
                            >
                              Edit
                            </button>
                            <button
                              class="btn btn-sm btn-danger"
                                   disabled={!isAdmin} // ❌ normal user ke liye disable
                                                         style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
                              onClick={() =>
                                handleDelete(rec.store_settings_id)
                              }
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" class="text-center">
                          No Records Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* <div class="col-xxl-2"></div> */}
        </div>
      </div>
    </div>
  );
}

export default Units;
